import firebase, { collection, getDocs } from '../../src/config/firebase';
require('firebase/auth')

const db = firebase.firestore();


const freightService = {

    async deleteFreight(id) {

        db.collection('freight')
            .doc(id)
            .delete()
            .catch(error => {
                alert('Erro ao deletar esse frete, contate o adm do sistema')
                console.log('Erro ao deletar esse frete')

            });
    },

    async saveStatusQueueFreight(id, idQueue, status) {
        console.log("[saveStatusQueueFreight] Salvando status na fila do frete " + status)

        var data = {
            status: status
        }

        db.collection('freight')
            .doc(id)
            .collection('queue')
            .doc(idQueue)
            .update(data)
            .catch(error => {
                console.log(error)
            });
    },

    async saveDriverQueueFreight(idFreight, idDriver, data) {
        console.log("[saveDriverQueueFreight] Salvando status na fila do frete ")

        console.log(data)

        try {

            // Deletar todos os documentos da collection 'queue' antes de adicionar
            const queueRef = db.collection('freight')
                .doc(idFreight)
                .collection('queue');
            
            const queueSnapshot = await queueRef.get();
            
            // Deletar todos os documentos em batch
            const batch = db.batch();
            queueSnapshot.docs.forEach(doc => {
                batch.delete(doc.ref);
            });
            await batch.commit();
            
            console.log(`[saveDriverQueueFreight] ${queueSnapshot.size} documento(s) deletado(s) da fila`);
            
            // Adicionar o novo documento
            await queueRef.doc(idDriver).set(data);
            console.log(`[saveDriverQueueFreight] Novo documento adicionado na fila`);
        } catch (error) {
            console.log("[saveDriverQueueFreight] Erro:", error);
        }
    },

    async deleteDriverQueueFreight(idFreight, idDriver) {
        console.log("[deleteDriverQueueFreight] Removendo motorista da fila do frete");

        try {
            await db.collection('freight')
                .doc(idFreight)
                .collection('queue')
                .doc(idDriver)
                .delete();
            console.log(`Motorista ${idDriver} removido da fila do frete ${idFreight}`);
        } catch (error) {
            console.error("Erro ao remover motorista da fila do frete:", error);
        }
    },


    async deleteAllFreightQueueMyFreight(idFreight) {
        console.log("[deleteDriverQueueFreight] Deletando todos os fretes da lista de Meus fretes dos motoristas da fila do frete " + idFreight);

        try {
            const result = await db.collection('freight')
                .doc(idFreight)
                .collection('queue')
                .get();

            console.log("[deleteAllFreightQueueMyFreight] " + result.docs.length + " documento(s) encontrado(s) na fila do frete " + idFreight)
                
            // Iterar sobre cada documento da fila
            for (const queueDoc of result.docs) {
                const queueData = queueDoc.data();
                const driverUser = queueData.driver_user; // uid do Driver

                if (driverUser) {
                    // Buscar documentos na myFreightsList do driver com idFreight e status "line"
                    const myFreightsSnapshot = await db.collection('drivers_users')
                        .doc(driverUser)
                        .collection('myFreightsList')
                        .where('uidFreight', '==', idFreight)
                        .get();
                    
                    // Deletar cada documento encontrado
                    const batch = db.batch();
                    myFreightsSnapshot.docs.forEach(doc => {
                        batch.delete(doc.ref);
                    });
                    
                    if (myFreightsSnapshot.docs.length > 0) {
                        await batch.commit();
                        console.log(`[deleteAllFreightQueueMyFreight] ${myFreightsSnapshot.docs.length} documento(s) deletado(s) do driver ${driverUser}`);
                    }
                }
            }

        } catch (error) {
            console.error("Erro ao deletar todos os fretes da lista de Meus fretes dos motoristas da fila do frete:", error);
            return false;
        }

        return true;
    },


    async updateStatusFreight(idFreight, status, codeStatus) {
        console.log("[updateStatusFreight] Salvando status no frete" + status + "Codigo: " + codeStatus)

        var chosenStatus = {
            describe: status,
            code: codeStatus
        }

        var data = {
            status: chosenStatus
        }



        db.collection('freight')
            .doc(idFreight)
            .update(data)
            .catch(error => {
                console.log(error)
            });
    },

    async searchCurrentWay(idFreight) {


        // return {
        //     latitude: -8.071562122327835,
        //     longitude: -34.927362241277,

        //     timestamp: 1725113176452
        // }

        return db.collection('freight')
            .doc(idFreight)
            .collection('positions')
            .orderBy('timestamp', "desc")
            .limit(1)
            .get();
    },


    async getFreightByIdContractNumber(contractNumber) {
        // console.log(contractNumber)
        return db.collection('freight')
            .where("numberSerial", "==", contractNumber)
            .get();
    },

    //#busca a posição mais antiga do frete, posição inicial
    async searchFirstWay(idFreight) {
        return await db.collection('freight')
            .doc(idFreight)
            .collection('positions')
            .orderBy('timestamp')
            .limit(1)
            .get();
    },
    //#busca as posições após a ultima recebida 
    async searchLatestPositions(idFreight, lastPositionReceived) {

        return await db.collection('freight')
            .doc(idFreight)
            .collection('positions')
            .orderBy('timestamp')
            .startAfter(lastPositionReceived)
            .get();
    },

    async freightDeliveredEffect() {

        return db
            .collection('freight').doc()
            .collection('stopping_points')
            // .where('concluded', '==', true)
            .get()
    },

    async getAllFreights() {
        return db.collection('freight').orderBy('createData', 'desc').get();
    },

    async getFreightById(idFreight) {
        return db.collection('freight')
            .doc(idFreight)
            .get();
    },

    async getFreightByIdd(idFreight) {
        // 1. Busca o documento principal (freight)
        const docRef = db.collection('freight').doc(idFreight);
        const docSnap = await docRef.get();

        if (!docSnap.exists) {
            return null; // Ou lançar um erro se preferir
        }

        const freightData = docSnap.data();

        // 2. Busca a subcoleção 'stopping_points'
        const stoppingPointsSnapshot = await docRef.collection('stopping_points').get();

        // Mapeia os documentos da subcoleção para um array
        const stoppingPointsList = stoppingPointsSnapshot.docs.map(doc => {
            return { id: doc.id, ...doc.data() };
        });

        // 3. Retorna tudo junto em um único objeto
        return {
            id: docSnap.id,
            ...freightData,
            stopping_points: stoppingPointsList // Adiciona a lista dentro do objeto final
        };
    },


    async getFreightsInProgressAll() {

        return db.collection('freight')
            .where("status.describe", "==", "Em transito")
            .orderBy('createData', 'desc')
            // .where('status.describe', 'not-in', ['Em Analise do motorista', 'Em Analise de perfil', 'Pendente de contratação'])
            .get()
        // .where('status.describe', 'not-in', ['Em Analise do motorista'])
    },

    async getFreightsInProgress(idShipper) {

        console.log(idShipper)

        return db.collection('freight')
            .where("status.describe", "==", "Em transito")
            .where("shipper.uid", "==", idShipper)
            .orderBy('createData', 'desc')
            .get()
    },

    async getFreightsInProgressMultiplesUIDs(idShipper) {

        return db.collection('freight')
            .where("status.describe", "==", "Em transito")
            .where("shipper.uid", "in", idShipper)
            .orderBy('createData', 'desc')
            // .where('status.describe', 'not-in', ['Em Analise do motorista', 'Em Analise de perfil', 'Pendente de contratação'])
            .get()
        // .where('status.describe', 'not-in', ['Em Analise do motorista'])
    },

    async getFreightsInPendente(idShipper) {
        return db.collection('freight')
            .where("status.describe", "==", "Pendente de contratação")
            .where("shipper.uid", "==", idShipper)
            .orderBy('createData', 'desc')
            // .where('status.describe', 'not-in', ['Em Analise do motorista', 'Em Analise de perfil', 'Pendente de contratação'])
            .get()
        // .where('status.describe', 'not-in', ['Em Analise do motorista'])
    },

    async getFreightsHired(idShipper) {
        return db.collection('freight')
            .where('status.describe', '==', "Contratado")
            .where("shipper.uid", "==", idShipper)
            .orderBy('createData', 'desc')
            // .where('status.describe', 'not-in', ['Em Analise do motorista', 'Em Analise de perfil', 'Pendente de contratação'])
            .get()
        // .where('status.describe', 'not-in', ['Em Analise do motorista'])
    },

    async freightAllFinalizado() {
        return db.collection('freight')
            .where("status.describe", "==", "Finalizado")
            .get();
    },

    async freightFinalizadoUid(idShipper) {
        return db.collection('freight')
            .where("status.describe", "==", "Finalizado")
            .where("shipper.uid", "==", idShipper)
            .get();
    },

    async freightFinalizadoMultiplesUIDs(idShipper) {
        return db.collection('freight')
            .where("status.describe", "==", "Finalizado")
            .where("shipper.uid", "in", idShipper)
            .get();
    },

    async getFreightsByDriverId(idDriver) {

        var retorno = await db.collection('freight')
            .where('freight.getDriverFreight.uidDriver', '==', idDriver)
            .get()

        return retorno
    },


    async getPositionsByFreight(idFreight) {
        return db
            .collection('freight')
            .doc(idFreight)
            .collection('positions')
            .orderBy('timestamp', "desc")
            .get();
    },

    async getStoppingPointsByFreight(idFreight) {
        return db.collection('freight')
            .doc(idFreight)
            .collection('stopping_points')
            .orderBy('stop_order')
            .get()
    },

    async freightInTravel(idShipper) {
        return db.collection('freight')
            .where('status.describe', '==', 'Em transito')
            .where("shipper.uid", "==", idShipper)
            .get();
    },

    async freightDelivered(idFreight) {
        return db
            .collection('freight')
            .doc(idFreight)
            .collection('stopping_points')
            .where('concluded', '==', true)
            .get()
    },

    async freightAllDeliveredEfeccts(idShipper) {
        try {
            let qtdDelivery = 0;

            const freightsSnapshot = await db.collection('freight')
                .where("shipper.uid", "==", idShipper)
                .get();

            const deliveriesPromises = freightsSnapshot.docs.map(async (frete) => {
                const stoppingPointsSnapshot = await db
                    .collection('freight')
                    .doc(frete.id)
                    .collection('stopping_points')
                    .where('concluded', '==', true)
                    .get();
                return stoppingPointsSnapshot.size;
            });

            const deliveriesCounts = await Promise.all(deliveriesPromises);

            // Somar todas as entregas
            qtdDelivery = deliveriesCounts.reduce((total, count) => total + count, 0);

            console.log(qtdDelivery)

            return qtdDelivery;
        } catch (error) {
            console.error("Erro ao buscar entregas:", error);
            throw error; // ou retorne algo padrão, se preferir
        }
    },

    async freightAllDeliveredNeedEfeccts(idShipper) {
        try {
            let qtdDelivery = 0;

            const freightsSnapshot = await db.collection('freight')
                .where("shipper.uid", "==", idShipper)
                .get();

            const deliveriesPromises = freightsSnapshot.docs.map(async (frete) => {
                const stoppingPointsSnapshot = await db
                    .collection('freight')
                    .doc(frete.id)
                    .collection('stopping_points')
                    .where('concluded', '==', false)
                    .get();
                return stoppingPointsSnapshot.size;
            });

            const deliveriesCounts = await Promise.all(deliveriesPromises);

            // Somar todas as entregas
            qtdDelivery = deliveriesCounts.reduce((total, count) => total + count, 0);

            console.log(qtdDelivery)

            return qtdDelivery;
        } catch (error) {
            console.error("Erro ao buscar entregas:", error);
            throw error; // ou retorne algo padrão, se preferir
        }
    },

    async freightAllDelivered() {

        let qtdDelivery = 0;

        db.collection('freight').get().then(async item => {

            item.docs.forEach(async frete => {

                db.collection('freight').doc(frete.id).collection('stopping_points')
                    .get().then(async (result) => {
                        qtdDelivery = qtdDelivery + result.size;
                    });

                return qtdDelivery;
            });

        }).catch(error => {
            console.error(error)
        });

    },

    async freightWithOcurrency() {

        return db
            .collection('freight')
            .doc()
            .collection('stopping_points')
            .get();

    },

    async allFreightsFinished(idShipper) {
        return db
            .collection('freight')
            .where("status.describe", "==", "Finalizado")
            .where("shipper.uid", "==", idShipper)
            .get()
    },

    /**
    * Busca um shipper pelo ID fornecido.
     * @param {*} idShipper  
     * @returns Se o documento existir, ele retorna os dados do documento
     * @returns Se o documento não existir, ele retorna null
     * @returns Se houver um erro, ele registra o erro no console
     */
    async getShipperById(idShipper) {
        try {
            // Busca um documento diretamente pelo seu ID
            const docRef = db.collection('shipper').doc(idShipper);
            const docSnap = await docRef.get();

            if (docSnap.exists) {

                return docSnap.data();
            } else {
                console.log("Nenhum shipper encontrado com este ID!");
                return null;
            }
        } catch (error) {
            console.log("Erro no serviço ao buscar shipper por ID:", error);

        }
    }

}

export default freightService;